// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1696009420454
      var cssReload = require("/Applications/MAMP/htdocs/killick-tire/wp-content/themes/jac/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  